import { Injectable } from '@angular/core';

@Injectable()
export class Globals {

  public isLoogedIn: boolean = false;
  
}